import React, {Component} from 'react';
import Parameter from "./Parameter";
import { connect } from "react-redux";
import {addNewParameter} from "../../../../store/actions/parameters";
import {endpointFieldChange} from "../../../../store/actions/endpoints";
import {isParametersValid} from "../../ClassicFunctions";
import ClassicCustomParametersNotice from "../../ClassicCustomParametersNotice";

const Parameters = (props) => {

	const { parameters, id, sectionVisibility, endpointFieldChange, premium } = props;

	return (
			<div id="poststuff" className="parameters-box">
				<div id="slugdiv" className="postbox ">
					<h2 className="hndle ui-sortable-handle" onClick={ e => endpointFieldChange( !sectionVisibility, id, 'parametersSection' ) }><span>Custom Parameters ({ props.parameters.length })</span></h2>
					<div className="inside" style={{display: sectionVisibility ? 'block' : 'none'}}>
						<p>Define custom parameters for your endpoint. Those custom parameters are a way to catch end user input and use it on your endpoint settings.</p>

            <ClassicCustomParametersNotice />

						{parameters.map((param, index) => <div className='RestRoutesParameter' key={index}><Parameter id={index} key={index} param={param} endpointId={id}/></div>)}
						<br/>

						<button onClick={() => (premium || isParametersValid(props.parameters.length)) && props.addNewParameter(id)} className="button-secondary">Add new parameter</button>
					</div>
				</div>
			</div>
	);
};

const mapStateToProps = ( state, props ) => ({
	id: props.id,
	parameters: state.settings.endpoints[props.id].parameters,
	sectionVisibility: state.settings.endpoints[props.id].parametersSection,
  premium: state.premium
});

const mapDispatchToProps = dispatch => ({
	addNewParameter: ( endpointId ) => dispatch( addNewParameter( endpointId ) ),
	endpointFieldChange: ( value, endpointId, field ) => dispatch( endpointFieldChange( value, endpointId, field ) ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Parameters);
